export enum BIOrigin {
  AddPanel = 'addpanel',
}

export enum BIComponent {
  ErrorState = 'errorState',
}
